export default __webpack_public_path__ + "static/media/Street+Student.357d1302.png";